<template>
  <div class="form-div">
    <div class="img-box">
      <img src="../../img/study/pc-bg.png" alt="" class="pic"/>
    </div>
    <div class="cont">
      <img src="../../img/study/pc-pic01.png" class="desc-pic"/>
      <form action="" ref="formData" class="form">
        <div class="title">海纳易学国际教育</div>
<!--        <div class="num">目前已有近{{count}}人报名咨询</div>-->
        <div class="num">目前已有近2万+人报名咨询</div>
        <div class="form-item">
          <div class="u-item">
            <div class="name">姓名</div>
            <input type="text" class="input" v-model="formData.name" id="name" placeholder="请输入您的姓名"/>
          </div>
          <div class="u-item">
            <div class="name">手机号</div>
            <input
                type="tel"
                id="tel"
                v-validate="'required|isMobile'"
                data-vv-name="手机号码"
                :class="colorShow ? 'input' : 'input yellow-border'"
                v-model="formData.mobile"
                ref="mobileInput"
                @blur="mobileBlur"
                placeholder="请输入您的手机号"
            />
          </div>

          <div class="u-item">
            <div class="name">验证码</div>
            <div class="u-item-verification">
              <input
                  type="tel"
                  style="width: 53%;border: none"
                  v-validate="'required'"
                  data-vv-name="验证码"
                  v-model="mobileCode"
                  class="input"
                  ref="codeInput"
                  placeholder="请输入"
              />
              <span @click="getCode" class="verification">{{ verificationCode }}</span>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="u-item" style="width: 100%">
            <div class="name">留言</div>
            <textarea class="input text-area" v-model="formData.message" placeholder="请输入"/>
          </div>
        </div>
        <div class="submit" @click="saveAllInfo">立即咨询</div>
        <div class="tip">咨询成功后将通过电话联系您留言</div>
        <div class="foot">
          <span>联系地址：北京市海淀区学院南路12号-北京师范大学京师科技大厦A座13层</span>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import {
  getInsert,
  getTradeList,
  getAreaList,
  getCountList,
  advertisersCallback,
  getCodeFun,
  getVerifyCode,
} from "./apis.js";

export default {
  name: "Index",
  data() {
    return {
      formData: {
        name: "",
        mobile: "",
        // area: "",
        // trade: "",
        message: '', // 留言
        channelCode: "留学新媒体",
        sourceType: "留学新媒体"
      },
      areaProvinceList: [],
      areaList: [],
      areaCityList: [],
      tradeList: [], //所属行业
      areaProvinceId: "",
      areaCityId: "",
      province: "",
      city: "",
      colorShow: true,
      count: 0,
      pValue: "",
      status: true,
      timer: 60,
      verificationCode: "获取验证码",
      codeFocus: false,
      mobileCode: "", //短信验证码
    };
  },
  methods: {
    getCode() {
      if (this.formData.mobile == "") {
        this.$layer.msg("手机号码不能为空", {time: 3});
        this.$refs.mobileInput.focus();
      } else {
        if (
            this.errors.items.length != 0 &&
            this.errors.items[0].field == "手机号码"
        ) {
          this.$layer.msg(this.errors.items[0].msg, {time: 3});
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
        if (this.status) {
          this.status = false;
          var count = this.timer;
          this.verificationCode = count + "s后重新获取";
          var timer = setInterval(() => {
            if (count === 0) {
              clearInterval(timer);
              this.verificationCode = "获取验证码";
              this.status = true;
            } else {
              count--;
              this.verificationCode = count + "s后重新获取";
            }
          }, 1000);
          this.$refs.codeInput.focus();
          this.getSmsCode();
        }
      }
    },
    async getSmsCode() {
      //获取验证码
      try {
        let param = {
          mobile: this.formData.mobile,
        };
        let {data} = await getCodeFun(param);
        if (data.code == 1000) {
          this.$layer.msg(data.message, {time: 3});
        }else{
          this.$layer.msg(data.message, {time: 3});
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVerifyCode() {
      //验证短信验证码是否正确
      try {
        let param = {
          mobile: this.formData.mobile,
          mobileCode: this.mobileCode,
        };
        let {data} = await getVerifyCode(param);
        if (data.code == 1000) {
          //						this.$layer.msg(data.message, {time: 3});
          this.saveInfo();
        } else {
          console.log("验证码错误",data.message);
          this.$layer.msg(data.message, {time: 3});
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveInfo() {
      //保存
      try {
        if (this.formData.name == " ") {
          this.$layer.msg(data.message, {time: 3});
        }
        let {data} = await getInsert(this.formData);
        if (data.code == 1000) {
          // console.log("保存接口返回的数据", data);
          alert(data.message)
          // var others = {
          //这个参数必须是对象
          // 所属行业: this.formData.trade,
          //							}
          // };
          // sendPage($("#tel").val(), $("#name").val(), others, {});
          this.$layer.msg(data.message, {time: 3});
          // this.advertisersCallback();
        } else {
          console.log("else", data.message)
          this.$layer.msg(data.message, {time: 3});
          // this.advertisersCallback();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async advertisersCallback() {
      //广告回调
      try {
        let params = {
          p: this.pValue,
        };
        let {data} = await advertisersCallback(params);
        console.log("广告回调返回数据", data);
      } catch (err) {
        console.log(err);
      }
    },
    saveAllInfo() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          //						this.saveInfo();
          this.getVerifyCode();
        }
        console.log("this.errors.items[0].rule",this.errors.items)
        if (this.errors.items[0].rule == "required") {
          this.$layer.msg(`${this.errors.items[0].field}不能为空`, {time: 3});
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
        if (
            this.errors.items.length != 0 &&
            this.errors.items[0].field == "手机号码"
        ) {
          this.$layer.msg(this.errors.items[0].msg, {time: 3});
          this.$refs.mobileInput.focus();
          this.colorShow = false;
          return;
        }
      });
    },
    // async getTradeList() {
    //   let params = {
    //     dictType: "trade_detail",
    //     pageSize: "10000",
    //   };
    //   try {
    //     let {data} = await getTradeList(params);
    //     console.log("所属行业数据", data);
    //     this.tradeList = data.data.content;
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    async getCountList() {
      //获取人数
      try {
        let {data} = await getCountList();
        this.count = data.data;
      } catch (err) {
        console.log(err);
      }
    },
    mobileBlur() {
      //手机号码input失焦事件
      this.colorShow = true;
    },
    // async getAreaList() {
    //   //获取所在城市
    //   let parentAreaId = "";
    //   if (this.province != "" && this.city == "") {
    //     parentAreaId = this.areaProvinceId;
    //   } else if (this.province != "" && this.city != "") {
    //     parentAreaId = this.areaCityId;
    //   } else {
    //     parentAreaId = "";
    //   }
    //   let params = {
    //     parentAreaId: parentAreaId,
    //     pageSize: "10000",
    //   };
    //   try {
    //     let {data} = await getAreaList(params);
    //     console.log("获取城市数据", data);
    //     if (parentAreaId != "" && this.areaCityId == "") {
    //       this.areaCityList = data.data.content; //获取市
    //     } else if (parentAreaId != "" && this.areaCityId != "") {
    //       this.areaList = data.data.content; //获取县
    //     } else {
    //       this.areaProvinceList = data.data.content; //获取省
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
  },
  // watch: {
  //   province: {
  //     handler: function (val) {
  //       console.log("val", val);
  //       this.areaProvinceId = val;
  //       this.city = "";
  //       this.formData.area = "";
  //       this.getAreaList();
  //     },
  //   },
  //   city: {
  //     handler: function (val) {
  //       console.log("val", val);
  //       this.areaCityId = val;
  //       this.formData.area = "";
  //       this.getAreaList();
  //     },
  //   },
  // },
  mounted() {
    this.getCountList();
    // this.getAreaList();
    // this.getTradeList();
    this.pValue = this.$route.query.p;
    console.log("this.pValue", this.pValue);
  },
};
</script>

<style scoped>
.form-div {
  padding-bottom: 30px;
  background: #ececec;
}

.img-box {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 1;
}

.img-box .pic {
  display: inline-block;
  width: 100%;
}

.cont {
  width: 1200px;
  margin: 0 auto;
}

.desc-pic {
  position: relative;
  margin-top: -30px;
  z-index: 99;
  width: 100%;
  vertical-align: middle;
}

.form {
  background: #FFFFFF;
  padding: 20px 0;
}

.title {
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 24px;
  color: #000000;
  line-height: 27px;
  padding-top: 40px;
}

.num {
  padding-top: 14px;
  font-size: 16px;
  color: #555555;
  padding-bottom: 30px;
}

.form-item {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
}

.u-item-verification {
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #CCCCCC;
}

.verification {
  width: 35%;
  height: 47px;
  line-height: 47px;
  background: #FFFFFF;
  border-radius: 6px;
  font-weight: 500;
  font-size: 15px;
  color: #0086C9;
  display: inline-block;
  text-align: right;
  position: relative;
  cursor: pointer;
}

.verification:before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 15px;
  left: 0;
  width: 2px;
  height: 13px;
  background: #C7D5E1;
}


.button div {
  width: 30%;
  height: 32px;
  background: #fff;
  display: inline-block;
  float: left;
  text-align: center;
  line-height: 32px;
  margin-left: 10px;
  opacity: 0.7;
  margin-top: 280px;
  border-radius: 12px;
  margin-bottom: 30px;
}

.u-item {
  width: 30%;
  margin-bottom: 15px;
  box-sizing: border-box;
  text-align: left;
}

.name {
  font-size: 15px;
  margin-top: 10px;
  color: #000000;
  margin-bottom: 10px;
  width: 290px;
}

.input {
  width: 100%;
  height: 47px;
  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #CCCCCC;
  padding-left: 5px;
}

.text-area {
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  padding: 10px;
  box-sizing: border-box;
  height: 106px;
  border-radius: 5px;
}

.submit {
  width: 80%;
  height: 49px;
  background: #0086C9;
  color: #fff;
  font-size: 15px;
  line-height: 49px;
  text-align: center;
  margin: 20px auto;
  border-radius: 6px;
  cursor: pointer;
}

.tip {
  font-size: 14px;
  color: #000000;
  margin-bottom: 50px;
}

.foot span {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/studyAbroadPc.vue